import { INiche } from "@/common/services/types";

import { NichePreviewAvatar } from "@/components/niches/NichePreviewAvatar";
import { NichePreviewInfo } from "@/components/niches/NichePreviewInfo";
import { NichePreviewButton } from "@/components/niches/NichePreviewButton";
import { NichePreviewImages } from "@/components/niches/NichePreviewImages";

import "./NichePreview.scss";
import { useSfw } from "@/common/hooks/useSfw";
import { metricsBus, EventSource, NichePreviewClickInitiator } from "@/common/buses";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

interface INichePreviewProps {
  niche: INiche;
  following: boolean;
  withJoin?: boolean;
  withPreview?: boolean;
  onPreviewClick?: () => void;
  onFollow: (id: string, status: boolean) => void;
}

export const NichePreview = (props: INichePreviewProps) => {
  const {
    following,
    withPreview,
    withJoin,
    onFollow,
    onPreviewClick
  } = props;

  const { isLoading, sanitizeNiche } = useSfw();
  const eventSource = useAnalyticsStore((state) => state.eventSource);

  const niche = sanitizeNiche(props.niche);

  const emitPreviewClick = (initiator: NichePreviewClickInitiator) => {
    metricsBus.emit("nichePreviewClicked", {
      nicheId: niche.id,
      initiator,
      source: eventSource?.name ?? EventSource.Other,
    });
  };

  const onMetaClick = () => {
    onPreviewClick?.();
    emitPreviewClick("meta");
  };

  const onImageClick = () => {
    onPreviewClick?.();
    emitPreviewClick("image");
  };

  const onButtonClick = (initiator: NichePreviewClickInitiator) => {
    onPreviewClick?.();
    emitPreviewClick(initiator);
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="NichePreview">
      <div className="NichePreview-Header">
        <NichePreviewAvatar niche={niche} onPreviewClick={onMetaClick} />
        <NichePreviewInfo niche={niche} onPreviewClick={onMetaClick} />
        <NichePreviewButton
          niche={niche}
          following={following}
          withJoin={withJoin}
          onFollow={onFollow}
          onPreviewClick={onButtonClick} />
      </div>

      <NichePreviewImages niche={niche} withPreview={withPreview} onPreviewClick={onImageClick} />
    </div>
  );
};
